import React, { useContext } from 'react'
import { BusinessContext } from '../../../../../contexts/businessContext'
import { MotorBikesContext } from '../../../../../contexts/motorBikesContext'
import TableComponent from '../../../../../elements/TableComponent'
import { useGetCombos } from '../../../../../hooks/useGetCombos'

const TableOfCombos = () => {

    const { currentService = {} } = useContext(MotorBikesContext)

    const { businessData = {} } = useContext(BusinessContext)

    const { combos = [] } = useGetCombos({ currentService, CardCode: businessData?.CardCode })

    return <div className="text-center">
        {
            combos.length > 0 ?
                <TableComponent columns={
                    <>
                        <th>Cod Factura</th>
                        <th>Item</th>
                        <th>Descripción</th>
                        <th>Fecha</th>
                        <th>Pendiente</th>
                    </>
                }
                    id="docRelTalbe"
                >
                    {
                        combos.sort((a, b) => a.DocDate.localeCompare(b.DocDate) || b.Dscription - a.Dscription).map((c, i) =>
                            <tr key={i}>
                                <td>{c.FolNumFrom}</td>
                                <td>{c.ItemCode}</td>
                                <td className="text-truncate" title={c.Dscription ? c.Dscription : ''}>{c.Dscription}</td>
                                <td>{c.DocDate}</td>
                                <td>{c.OpenQty + '/' + c.Quantity}</td>
                            </tr>
                        )
                    }
                </TableComponent>
                :

                <p>El cliente no posee Combos ni services Facturados</p>
        }
    </div>
}

export default React.memo(TableOfCombos)